import { Badge } from "@atoms"

import { LabelsBadgesProps } from "./LabelsBadges.types"

// Labels longer than this are truncated (code-point aware so emoji stay intact).
const MAX_LABEL_LENGTH = 15
// At most this many badges render. Beyond it, the first two labels show and the
// rest collapse into a "+N labels" counter.
const MAX_VISIBLE_LABELS = 3

function truncateLabel(name: string): string {
    const characters = Array.from(name)
    if (characters.length <= MAX_LABEL_LENGTH) {
        return name
    }
    return `${characters.slice(0, MAX_LABEL_LENGTH).join("")}…`
}

export default function LabelsBadges(props: LabelsBadgesProps) {
    const { labels, size = "md" } = props

    if (labels.length === 0) {
        return null
    }

    // Up to three labels render in full. Beyond that, the first two show and the
    // remainder collapse into a counter that lists them in its tooltip.
    const hasOverflow = labels.length > MAX_VISIBLE_LABELS
    const visibleLabels = hasOverflow ? labels.slice(0, 2) : labels
    const hiddenLabels = hasOverflow ? labels.slice(2) : []

    return (
        <>
            {visibleLabels.map((label) => (
                <Badge key={label.id} size={size} tooltip={label.name}>
                    {truncateLabel(label.name)}
                </Badge>
            ))}
            {hiddenLabels.length > 0 && (
                <Badge size={size} tooltip={hiddenLabels.map((label) => label.name).join("\n")}>
                    +{hiddenLabels.length} labels
                </Badge>
            )}
        </>
    )
}
